import type { ResponsiveStylesStructured } from '@duda-co/responsive-styles';
import { RuntimeMediaQuery } from '@duda-co/responsive-styles/RuntimeMediaQuery';
import FieldError from 'client/widget-components/components/FieldError';
import React, { FC } from 'react';

interface CustomizationFieldErrorProps {
    error: string;
}

const CustomizationFieldError: FC<CustomizationFieldErrorProps> = ({
    error,
}: CustomizationFieldErrorProps) => (
    <FieldError error={error} styles={[fieldErrorCustomizationStyles]} />
);

const fieldErrorCustomizationStyles: ResponsiveStylesStructured = {
    [RuntimeMediaQuery.COMMON]: {
        borderRadius: '8px',
        opacity: 1,
        padding: '6px 12px',
        gap: '4px',
        backgroundColor: '#FEF5F5',
        color: '#B00020',
        marginBlockStart: '8px',
        minHeight: '32px',
        fontSize: '13px',
        lineHeight: '20px',
    },
};

export default CustomizationFieldError;
